import { IApplicationState } from '../../types/redux';

/**
 * Выбирает список вопросов
 */
export const selectQuestionList = ({ questionList }: IApplicationState) => questionList;
